import React, { useState, useEffect } from 'react';

// material-ui
import { CssBaseline, Alert, Divider, Grid} from '@mui/material';

//components
import AlertInfo from '../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../components/elements/AlertInfoDialog';
import TopBar from '../../components/nav/TopBar';
import PdfScanning from './components/PdfScanningComponent';
import PdfObject from './dataObjects/PdfObject';
import GenericForm from './components/GenericFormComponent';


const FormManagerApp = (): JSX.Element => {

    //set up browser title
    const pageTitle = 'Extranet - Form Processor';
    document.title = pageTitle;

    const applicationName = 'Form Processor';

    //set up state for the app
    const [isPdfScanningActive, setPdfScanningActive] = useState(true);
    const [isFormProcessed, setIsFormProcessed] = useState(false);
    const [selectedForm, setSelectedForm] = useState<PdfObject | null>(null);

    //payload
    useEffect(() => {
    }, []);


    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(true);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    const processForm = (form: PdfObject) => {
        setSelectedForm(form);
        setPdfScanningActive(false);
        setIsFormProcessed(true);
    }

    const closeGenericForm = () => {
        setPdfScanningActive(true);
        setIsFormProcessed(false);
    }

    return (
        <div>
            <Grid container sx={{ display: 'flex' }}>
                <CssBaseline />
                <TopBar applicationName={applicationName}></TopBar>
            </Grid>
            <Grid item xs={12} marginBottom={1}>
                <Divider />
            </Grid>
            {/*<Grid container sx={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '15px' }} >*/}
            {/*    <Grid item xs={2}>*/}
            {/*        <Stack direction="row" spacing={1} >*/}
            {/*            <Button variant="outlined" startIcon={<PictureAsPdfIcon />} onClick={()=>setPdfScanningActive(true)} >*/}
            {/*                Process Form*/}
            {/*            </Button>*/}
            {/*        </Stack>*/}
            {/*    </Grid>*/}
            {/*</Grid>*/}
            <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '15px' }} >
                {
                    isPdfScanningActive &&
                    <Grid item xs={12} display="flex" justifyContent="center" marginBottom={5}>
                            <Alert severity="info" icon={false} ><b>Please select the form to be processed, and add the time stamp, and click "Process Form" button to proceed.</b></Alert>
                    </Grid>
                }
                {
                    isPdfScanningActive &&
                    <PdfScanning processForm={processForm} ></PdfScanning>
                }
                {
                    isFormProcessed && selectedForm && 
                    <GenericForm selectedForm={selectedForm} closeGenericForm={closeGenericForm}></GenericForm>
                }
            </Grid>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </div>
    );
};

export default FormManagerApp;